import React from 'react';
import { NavLink } from 'react-router-dom';
import './AppList.css';

function AppList() {
  return (
    <div className="app-list">
      <nav className="breadcrumb">
        <NavLink to="/">Home</NavLink>
        <span className="separator">></span>
        <span className="current">Apps</span>
      </nav>
      
      <h1>All Apps</h1>
      <div className="apps-grid">
        <a
          href="/apps/context-switcher"
          target="_blank"
          rel="noopener noreferrer"
          className="app-card"
        >
          <div className="app-card-content">
            <h3>Context Switcher</h3>
            <span className="app-arrow">→</span>
          </div>
        </a>
      </div>
    </div>
  );
}

export default AppList;

